import { render, staticRenderFns } from "./PerformanceSpecs.vue?vue&type=template&id=5937420b&scoped=true&"
import script from "./PerformanceSpecs.vue?vue&type=script&lang=js&"
export * from "./PerformanceSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5937420b",
  null
  
)

export default component.exports